// Red Cell Theme JS
// Shopify handles form submission natively via the customer form.
// This file handles progressive enhancement only.

document.addEventListener('DOMContentLoaded', function () {
  // Animate hero elements in on load
  const animatables = document.querySelectorAll('.eyebrow, .hero-heading, .hero-sub, .subscribe-wrap');
  animatables.forEach(function (el, i) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
    el.style.transitionDelay = (i * 0.1) + 's';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        el.style.opacity = '1';
        el.style.transform = 'translateY(0)';
      });
    });
  });
});
